import { MODEL_TYPES, REQUEST_STATUSES } from '../constants/constants';
import { ProductEditApi } from '../api/products';
import { editPropDetailsPopupActions } from '../redux/slicers/editPropDetailsPopupSlicer';
import { model3dDetailsActions } from '../redux/slicers/model3dDetailsSlicer';
import { paginatedProductSelectors } from '../redux/slicers/admin/paginatedProductSlicer';
import { propDetailsPopupActions } from '../redux/slicers/propDetailsPopupSlicer';
import { useDispatch } from 'react-redux';
import { useDownloadEntity } from './useDownloadEntity';
import { useModelActions } from './useModelActions';
import { useNavigate } from 'react-router-dom';
import { REQUESTS_ROUTE } from '../constants/routePathConstants';
import { useUserContext } from '../contexts/UserContext';
import { warningToast } from '../helpers/toastHelper';

export const useProductActions = ({ item, modelType, refetchList }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { currentUser } = useUserContext();
  const { loading: downloadLoading, download3DFilesZip } = useDownloadEntity();
  const {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    addToCollection,
    requestTo3DFilesCollection,
    onRestore,
    onArchive,
    onSoftDelete,
    onSoftDeleteRestore,
  } = useModelActions({
    item,
    modelType: MODEL_TYPES.PRODUCT,
    selectors: paginatedProductSelectors,
    updateApi: ProductEditApi,
    refetchList:refetchList
  });

  const onEdit = (reqTagList = [], isEdit) => {
    const isRequestOrgAndCurrentOrgSame =
    +item?.request_details?.organization === +currentUser?.organization;
    if(reqTagList?.length && !isEdit && item?.request && item?.request_details?.id && item?.request_details?.status !== REQUEST_STATUSES.LIVE_ON_APP.value){
      if (isRequestOrgAndCurrentOrgSame) {
        navigate(`${REQUESTS_ROUTE}/${item?.request || item?.request_details?.id}`);
      } else {
        const message = item?.request_details?.organization_name
          ? `This request is in ${item?.request_details?.organization_name} org. Please switch to view.`
          : `This request belongs to another organization. Please switch to view.`;
        warningToast(message);
      }
      return
    }
    modelType === MODEL_TYPES.THREEDMODELS
      ? dispatch(model3dDetailsActions.show(item))
      : dispatch(propDetailsPopupActions.show(item));
  };

  const onEditInfo = () => dispatch(editPropDetailsPopupActions.show(item));

  return {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    addToCollection,
    onEdit,
    onEditInfo,
    requestTo3DFilesCollection,
    downloadLoading,
    download3DFilesZip,
    onRestore,
    onArchive,
    onSoftDelete,
    onSoftDeleteRestore,
  };
};
